<template>
    <div
        v-if="pagination.count > 0"
        class="container flex w-full flex-col justify-between gap-10 md:flex-row md:gap-5">
        <div class="flex-1 max-lg:hidden"></div>

        <BasePagination
            :pagination="pagination"
            :top-on-scroll />

        <div class="flex flex-1 items-center md:justify-end">
            <AtomDropdown
                v-model="itemsPerPage"
                :options="dropdownOptions"
                class="w-full md:max-w-[17rem]" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import AtomDropdown from '~/components/atom/atom-dropdown/AtomDropdown.vue'
import type { IDropdownOption } from '~/components/atom/atom-dropdown/atom-dropdown.types'
import BasePagination from '~/components/base/base-pagination/BasePagination.vue'
import type { BasePaginationTypes } from '~/components/base/base-pagination/base-pagination.type'

defineEmits(['change:items-per-page'])
const props = defineProps({
    itemsCount: {
        type: Number as PropType<number>,
        default: 0,
    },
    showItemsPerPage: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    defaultItemsPerPage: {
        type: Number as PropType<number>,
        default: 15,
    },
    pagesName: {
        type: String as PropType<string>,
        default: '',
    },
    pagination: {
        type: Object as PropType<BasePaginationTypes>,
        required: true,
    },
    topOnScroll: {
        type: Number as PropType<number>,
        default: 300,
    },
})

const route = useRoute()
const itemsPerPage = ref(Number(route.query.limit) || props.defaultItemsPerPage)

const dropdownOptions: IDropdownOption[] = [
    {
        text: '15' + ` ${props.pagesName}` + ' на странице',
        value: 15,
    },
    {
        text: '60' + ` ${props.pagesName}` + ' на странице',
        value: 60,
    },
]

watch(itemsPerPage, () => {
    setQuery([['limit', itemsPerPage.value]])

    setTimeout(() => {
        window.scrollTo({
            top: props.topOnScroll,
            behavior: 'smooth',
        })
    }, 500)
})
</script>
